<template>
  <v-item-group class="pb-7" id="submodality">
    <v-row class="pb-9">
      <v-col cols="12">
        <p class="quotation-title black--text font-weight-bold">
          {{ title }}
        </p>
      </v-col>
      <v-col
        v-for="(item, key) of listActiveSubModality"
        :key="key"
        cols="12"
        sm="5"
        md="3"
        class="pr-5 pb-5 d-flex justify-center justify-sm-start"
      >
        <QuotationCard
          @click="selectedItem(item)"
          :name="item.nome"
          :background="item.imagem"
          :class="{ 'base-card-active': findActiveItem(item) }"
          is-tooltip
          :tooltip-text="item.tooltip"
          is-icon
        />
      </v-col>
    </v-row>
    <v-divider />
  </v-item-group>
</template>
<script>
const subModalityType = [
  {
    title: "Judicial",
    id: 0
  },
  {
    title: "Execução Fiscal",
    id: 1
  },
  {
    title: "Execução Trabalhista",
    id: 2
  },
  {
    title: "Recursal",
    id: 3
  }
];

import CardDescriptionButton from "@/components/CardDescriptionButton.vue";

export default {
  data: () => ({
    list1: subModalityType
  }),
  components: {
    QuotationCard: CardDescriptionButton
  },
  mounted() {
    document.getElementById("submodality").scrollIntoView();
  },
  computed: {
    listActiveSubModality() {
      return this.list.filter(x => x.ativo == true);
    }
  },
  methods: {
    selectedItem(item) {
      this.$emit("subModality", item);
    },
    findActiveItem(item) {
      return this.model ? item.id === this.model.id : false;
    }
  },
  props: {
    model: {
      type: Object
    },
    list: {
      type: Array
    },
    title : {
      type : String,
      default : ()=>("SUB-MODALIDADES")
    }
  }
};
</script>
